export default __webpack_public_path__ + "static/media/Terms of Service.e1be62a7.pdf";